import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const IntroSection = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<>
			<p className="text-base">{translation.readyForCodelistsDescription}</p>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		readyForCodelistsDescription:
			'This project can now use codelists to store personal identifiable information. Read on for an introduction to how you can use digital codelists in Ledidi.'
	},

	[LanguageType.Norwegian]: {
		readyForCodelistsDescription:
			'Dette prosjektet kan nå bruke kodelister for å lagre personlig identifiserbar informasjon. Les videre for en introduksjon til hvordan du kan bruke digitale kodelister i Ledidi.'
	}
};
